import { useEffect, useState } from "react";

const navItems = [
  { label: "更新速览", href: "#feed" },
  { label: "推荐榜", href: "#ranking" },
  { label: "主题合集", href: "#collections" },
  { label: "维度对比", href: "#compare" },
  { label: "哪个好", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="flex h-16 w-full items-center gap-6 px-4 md:px-8">
        <a href="#top" className="flex shrink-0 items-center gap-2 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-article-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            黑料平台
          </span>
          <span className="hidden rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900 sm:inline-block">
            推荐指南
          </span>
        </a>

        <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <div className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 md:flex">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-search-line text-sm text-foreground-500"></i>
            </span>
            <input
              type="text"
              placeholder="搜索平台 / 合集"
              className="w-32 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none xl:w-44"
            />
          </div>
          <a
            href="#ranking"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-links-line text-sm"></i>
            </span>
            平台入口
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="grid grid-cols-2 gap-1 px-4 py-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}